import { Flex, Box, Float, Circle } from '@chakra-ui/react';
import { DownIcon, MentionMsgIcon } from '@halo/ui-chat-react';
import type { ReactNode } from 'react';

export interface MessageAffixProps {
  mentions?: number;
  readToBottom?: boolean;
  unreadCount: number;
  onMentionClick?: () => void;
  onUnreadClick: () => void;
  onBottomClick: () => void;
}

const MessageAffix = ({
  mentions,
  onMentionClick,
  readToBottom = false,
  unreadCount,
  onUnreadClick,
  onBottomClick,
}: MessageAffixProps) => {
  const haveUnread = useMemo(() => {
    return unreadCount > 0;
  }, [unreadCount]);
  const hasMention = useMemo(() => {
    return mentions !== undefined && mentions > 0;
  }, [mentions]);
  return (
    <Flex
      className="MessageAffix"
      flexDirection="column"
      w="9"
      pos="absolute"
      bottom="4"
      right="3"
      gap="4"
    >
      {hasMention && (
        <MentionMsgIconWrapper onClick={onMentionClick}>
          <Float placement="top-center">
            <Circle
              fontSize="xs"
              fontWeight="medium"
              bg="brand.100"
              color="white"
              w="auto"
              minW="4"
              height="4"
              px="1"
            >
              {mentions}
            </Circle>
          </Float>
          <MentionMsgIcon />
        </MentionMsgIconWrapper>
      )}
      {(readToBottom || haveUnread) && (
        <MentionMsgIconWrapper
          onClick={() => {
            if (haveUnread) {
              onUnreadClick();
            } else {
              onBottomClick();
            }
          }}
        >
          {haveUnread && (
            <Float placement="top-center">
              <Circle
                fontSize="xs"
                fontWeight="medium"
                bg="brand.100"
                color="white"
                w="auto"
                minW="4"
                height="4"
                px="1"
              >
                {unreadCount}
              </Circle>
            </Float>
          )}
          <DownIcon />
        </MentionMsgIconWrapper>
      )}
    </Flex>
  );
};

function MentionMsgIconWrapper({
  onClick,
  children,
}: {
  onClick?: () => void;
  children: ReactNode;
}) {
  return (
    <Box
      className="MentionMsgIconWrapper fadeIn"
      h="9"
      w="9"
      bg="bg"
      color="brand.100"
      borderRadius="2xl"
      cursor="pointer"
      display="flex"
      alignItems="center"
      justifyContent="center"
      pos="relative"
      onClick={onClick}
      css={{
        boxShadow: '0 2px 8px 0 rgba(102, 102, 102, 0.30)',
      }}
    >
      {children}
    </Box>
  );
}

const MemoizedMessageAffix = memo(MessageAffix);

export { MemoizedMessageAffix as MessageAffix };
